import * as THREE from 'three'
import SimplexNoise from 'simplex-noise'

// TerrainPlaneBufferGeometry
function TerrainPlaneBufferGeometry(_width, _height, _widthSegments, _heightSegments, _noiseFrequency)
{
    THREE.BufferGeometry.call(this)

    this.type = 'TerrainPlaneBufferGeometry'

    this.parameters = {
        width: _width,
        height: _height,
        widthSegments: _widthSegments,
        heightSegments: _heightSegments
    }

    const width = _width || 1
    const height = _height || 1
    const noiseFrequency = _noiseFrequency || 0

    const widthHalf = width / 2
    const heightHalf = height / 2

    const gridX = Math.floor(_widthSegments) || 1
    const gridY = Math.floor(_heightSegments) || 1

    const gridX1 = gridX + 1
    const gridY1 = gridY + 1

    const segmentWidth = width / gridX
    const segmentHeight = height / gridY

    let ix
    let iy

    // buffers
    const length = gridX1 * gridY1
    const vertices = new Float32Array(length * 3 * 4)
    const uvs = new Float32Array(length * 2 * 4)
    const guvs = new Float32Array(length * 2 * 4)
    const noises = new Float32Array(length * 1 * 4)
    const edgeRandoms = new Float32Array(length * 1 * 4)
    const edgeScafoldingRandoms = new Float32Array(length * 1 * 4)
    const edgeCenters = new Float32Array(length * 3 * 4)

    // Noise
    const simplexNoise = new SimplexNoise('burno')

    const noiseData = []
    for(iy = 0; iy < gridY1 + 1; iy++)
    {
        const noiseLine = []

        for(ix = 0; ix < gridX1 + 1; ix++)
        {
            const x1 = ix * segmentWidth - widthHalf
            const y1 = iy * segmentHeight - heightHalf
            noiseLine.push(simplexNoise.noise2D(x1 * noiseFrequency, y1 * noiseFrequency))
        }

        noiseData.push(noiseLine)
    }

    // generate vertices and uvs
    let i = 0
    for(iy = 0; iy < gridY1; iy++)
    {
        for(ix = 0; ix < gridX1; ix++)
        {
            const x1 = (ix + 0) * segmentWidth - widthHalf
            const x2 = (ix + 1) * segmentWidth - widthHalf
            const y1 = (iy + 0) * segmentHeight - heightHalf
            const y2 = (iy + 1) * segmentHeight - heightHalf

            // Z
            const z1 = noiseData[iy][ix]
            const z2 = noiseData[iy][ix + 1]
            const z3 = noiseData[iy + 1][ix]

            /**
             * Edge 1
             */
            vertices[i * 3 + 0] = x1
            vertices[i * 3 + 1] = y1
            vertices[i * 3 + 2] = 0
            vertices[i * 3 + 3] = x1
            vertices[i * 3 + 4] = y2
            vertices[i * 3 + 5] = 0
            // vertices.push(
            //     x1, y1, 0, // Bottom left
            //     x1, y2, 0  // Top left
            // )

            uvs[i * 2 + 0] = 0
            uvs[i * 2 + 1] = 0
            uvs[i * 2 + 2] = 0
            uvs[i * 2 + 3] = 1
            // uvs.push(
            //     0, 0,
            //     0, 1
            // )

            guvs[i * 2 + 0] = (ix + 0) / gridX1
            guvs[i * 2 + 1] = (iy + 0) / gridY1
            guvs[i * 2 + 2] = (ix + 0) / gridX1
            guvs[i * 2 + 3] = (iy + 1) / gridY1
            // guvs.push(
            //     (ix + 0) / gridX1, (iy + 0) / gridY1,
            //     (ix + 0) / gridX1, (iy + 1) / gridY1
            // )

            noises[i * 1 + 0] = z1
            noises[i * 1 + 1] = z3
            // noises.push(
            //     z1,
            //     z3
            // )

            const edge1Random = Math.random()
            edgeRandoms[i * 1 + 0] = edge1Random
            edgeRandoms[i * 1 + 1] = edge1Random
            // edgeRandoms.push(
            //     edge1Random,
            //     edge1Random
            // )

            const edge1ScafoldingRandom = Math.random()
            edgeScafoldingRandoms[i * 1 + 0] = edge1ScafoldingRandom
            edgeScafoldingRandoms[i * 1 + 1] = edge1ScafoldingRandom
            // edgeScafoldingRandoms.push(
            //     edge1ScafoldingRandom,
            //     edge1ScafoldingRandom
            // )

            const edge1Center = [x1, y1 - (y1 - y2) * 0.5, 0]
            edgeCenters[i * 3 + 0] = edge1Center[0]
            edgeCenters[i * 3 + 1] = edge1Center[1]
            edgeCenters[i * 3 + 2] = edge1Center[2]
            edgeCenters[i * 3 + 3] = edge1Center[0]
            edgeCenters[i * 3 + 4] = edge1Center[1]
            edgeCenters[i * 3 + 5] = edge1Center[2]
            // edgeCenters.push(
            //     ...edge1Center,
            //     ...edge1Center
            // )

            /**
             * Edge 2
             */
            vertices[i * 3 + 6] = x1
            vertices[i * 3 + 7] = y1
            vertices[i * 3 + 8] = 0
            vertices[i * 3 + 9] = x2
            vertices[i * 3 + 10] = y1
            vertices[i * 3 + 11] = 0
            // vertices.push(
            //     x1, y1, 0, // Bottom left
            //     x2, y1, 0  // Bottom right
            // )

            uvs[i * 2 + 4] = 0
            uvs[i * 2 + 5] = 0
            uvs[i * 2 + 6] = 1
            uvs[i * 2 + 7] = 0
            // uvs.push(
            //     0, 0,
            //     1, 0
            // )

            guvs[i * 2 + 4] = (ix + 0) / gridX1
            guvs[i * 2 + 5] = (iy + 0) / gridY1
            guvs[i * 2 + 6] = (ix + 1) / gridX1
            guvs[i * 2 + 7] = (iy + 0) / gridY1
            // guvs.push(
            //     (ix + 0) / gridX1, (iy + 0) / gridY1,
            //     (ix + 1) / gridX1, (iy + 0) / gridY1
            // )

            noises[i * 1 + 2] = z1
            noises[i * 1 + 3] = z2
            // noises.push(
            //     z1,
            //     z2
            // )

            const edge2Random = Math.random()
            edgeRandoms[i * 1 + 2] = edge2Random
            edgeRandoms[i * 1 + 3] = edge2Random
            // edgeRandoms.push(
            //     edge2Random,
            //     edge2Random
            // )

            const edge2ScafoldingRandom = Math.random()
            edgeScafoldingRandoms[i * 1 + 2] = edge2ScafoldingRandom
            edgeScafoldingRandoms[i * 1 + 3] = edge2ScafoldingRandom
            // edgeScafoldingRandoms.push(
            //     edge2ScafoldingRandom,
            //     edge2ScafoldingRandom
            // )

            const edge2Center = [x1 - (x1 - x2) * 0.5, y1, 0]
            edgeCenters[i * 3 + 6] = edge2Center[0]
            edgeCenters[i * 3 + 7] = edge2Center[1]
            edgeCenters[i * 3 + 8] = edge2Center[2]
            edgeCenters[i * 3 + 9] = edge2Center[0]
            edgeCenters[i * 3 + 10] = edge2Center[1]
            edgeCenters[i * 3 + 11] = edge2Center[2]
            // edgeCenters.push(
            //     ...edge2Center,
            //     ...edge2Center
            // )

            i += 4
        }
    }

    // build geometry
    this.addAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))
    this.addAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2))
    this.addAttribute('guv', new THREE.Float32BufferAttribute(guvs, 2))
    this.addAttribute('noise', new THREE.Float32BufferAttribute(noises, 1))
    this.addAttribute('edgeRandom', new THREE.Float32BufferAttribute(edgeRandoms, 1))
    this.addAttribute('edgeScafoldingRandom', new THREE.Float32BufferAttribute(edgeScafoldingRandoms, 1))
    this.addAttribute('edgeCenter', new THREE.Float32BufferAttribute(edgeCenters, 3))
}

TerrainPlaneBufferGeometry.prototype = Object.create(THREE.BufferGeometry.prototype)
TerrainPlaneBufferGeometry.prototype.constructor = TerrainPlaneBufferGeometry

export { TerrainPlaneBufferGeometry }



// WEBPACK FOOTER //
// ./src/components/app-experience/Experience/Geometries/TerrainPlane.js